module.exports = __webpack_public_path__ + "img/5-5.2efb4af4.svg";